import { useGetMe } from '@sara/api-client';
import { useParams } from '@tanstack/react-router';

/**
 * Returns the caller's membership for the active `:orgSlug` organization.
 *
 * `membership` is `null` on routes without `:orgSlug`, when the slug matches
 * no membership, or while `useGetMe` is still loading — callers that need to
 * distinguish "loading" from "no match" should also read `rest.isLoading`.
 * `isAdmin` is `false` in all of those cases.
 */
export function useActiveMembership() {
  // Cross-cutting hook: callers exist inside and outside the $orgSlug subtree,
  // so we can't use a `from`-scoped useParams (same caveat as useActiveOrganization).
  const params = useParams({ strict: false }) as { orgSlug?: string };
  const { data: me, ...rest } = useGetMe();

  const slug = params.orgSlug;
  const membership = slug
    ? (me?.memberships.find((m) => m.organization.slug === slug) ?? null)
    : null;

  return { membership, isAdmin: membership?.role === 'ADMIN', ...rest };
}
